import React from 'react';
import { ScaledViewport } from './ScaledViewport';
import { TeaserSnak } from './teaser/TeaserSnak';
type SnakStillProps = {
  /** Teaser screen index: 0 Hook · 1 Reframe · 2 Mini-sim · 3 Reveal · 4 Pen · 5 Proof. */
  screen: number;
  alt: string;
  /** Sizes the box the phone is fitted into (defaults to filling its parent). */
  className?: string;
};

/** A still image of one screen of the Ferring REKOVELLE teaser Snak, framed as a phone. */
export function SnakStill({
  screen,
  alt,
  className = 'h-full w-full'
}: SnakStillProps) {
  return <ScaledViewport baseWidth={390} baseHeight={760} bezel={3} still label={alt} className={`min-h-0 min-w-0 ${className}`} deviceClassName="bg-ink shadow-[0_10px_28px_rgba(14,27,51,0.18)]" data-id="element-701" data-mp="14ngmbcoejkny">
      <div className="flex h-full flex-col bg-white" data-id="element-702" data-mp="2k479oo7b71sb">
        <TeaserSnak initialScreen={screen} still data-id="element-703" data-mp="2k3p7laxyttch" />
      </div>
    </ScaledViewport>;
}